import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { ElMessage } from 'element-plus'
import Home from '../views/Home.vue'
import Index from '../views/Index.vue'
import Category from '../views/Category.vue'
import Template from '../views/Template.vue'
import Login from '../views/Login.vue'
import User from '../views/User.vue'
import Resume from '../views/Resume.vue'
import Order from '../views/Order.vue'
import Balance from '../views/Balance.vue'
import Token from '../views/Token.vue'
import store from '../store'
interface CustomMeta {
  title: string;
  redirectAlreadyLogin: boolean;
  requiredLogin: boolean;
}
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    children: [
      { path: '', name: 'home', component: Home, meta: { title: '欢迎来到简单简历' } },
      { path: '/categories', name: 'category', component: Category, meta: { title: '分类管理', disableLoading: true } },
      { path: '/templates', name: 'template', component: Template, meta: { title: '模版管理', disableLoading: true } },
      { path: '/users', name: 'user', component: User, meta: { title: '用户管理', disableLoading: true } },
      { path: '/resumes', name: 'resume', component: Resume, meta: { title: '简历管理', disableLoading: true } },
      { path: '/orders', name: 'order', component: Order, meta: { title: '订单管理', disableLoading: true } },
      { path: '/balances', name: 'balance', component: Balance, meta: { title: '代金券管理', disableLoading: true } },
      { path: '/tokens', name: 'token', component: Token, meta: { title: 'Token 管理', disableLoading: true } },
    ]
  }, {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录到简单简历'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach(async (to, from) => { 
  const { user } = store.state
  const { token, isLogin } = user
  const { redirectAlreadyLogin, title } = to.meta as unknown as CustomMeta
  if (title) {
    document.title = title
  }
  if (!isLogin) { 
    if (token) {
      try {
        const resp = await store.dispatch('fetchCurrentUser')
        const rawData = resp.data
        // RQYF-120
        // 如果用户不是 admin，那么就踢出去
        if (rawData.role !== 'admin') {
          ElMessage({
            type: 'error',
            message: '没有权限完成操作'
          })
          store.commit('logout')
          return '/login'         
        }
        if (redirectAlreadyLogin) {
          return '/'
        }
      } catch (e) {
        console.log(e)
        ElMessage({
          type: 'error',
          message: '登陆状态已过期 请重新登陆'
        })
        store.commit('logout')
        return '/login'
      }      
    } else {
      // console.log(from)
      // console.log(to)
      if (to.path !== '/login') {
        return '/login'
      }
    }
  } else {
    if (redirectAlreadyLogin) {
      return '/'
    }
  }
})
export default router
